import React from 'react';

const DiceAiButton = ({ itemId,onClick }) => {
    return (
        <div onClick={onClick} style={{position: "relative"}}>
            <div style={{
                position: "absolute",
                top: "-8px",
                left: "50%",
                transform: "translateX(-50%)",
                width: 0,
                height: 0,
                borderLeft: "8px solid transparent",
                borderRight: "8px solid transparent",
                borderBottom: "8px solid var(--primary-color)",
                zIndex: 1
            }}></div>
            <button 
                className="dice-ai-button" 
                style={{
                    backgroundColor: "var(--primary-color)",
                    color: "white",
                    padding: "3px 8px",
                    borderRadius: "4px",
                    border: "none",
                    cursor: "pointer",
                    marginLeft: "10px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                    transition: "all 0.2s ease",
                    marginTop: 10,
                    fontSize: "11px"
                }}
                onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    const tooltipElement = e.currentTarget.querySelector('.ai-tooltip');
                    if (tooltipElement) {
                        tooltipElement.style.visibility = "visible";
                        tooltipElement.style.opacity = "1";
                    }
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    const tooltipElement = e.currentTarget.querySelector('.ai-tooltip');
                    if (tooltipElement) {
                        tooltipElement.style.visibility = "hidden";
                        tooltipElement.style.opacity = "0";
                    }
                }}
                
            >
                <i className="fa fa-robot" style={{ fontSize: "10px" }}></i>
                Dice AI
                <div 
                    className="ai-tooltip"
                    style={{
                        position: "absolute",
                        bottom: "100%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#333",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        whiteSpace: "nowrap",
                        visibility: "hidden",
                        opacity: 0,
                        transition: "opacity 0.2s ease",
                        marginBottom: "8px",
                        zIndex: 100,
                        boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
                    }}
                >
                    AI suggestions
                    <div style={{
                        position: "absolute",
                        top: "100%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: 0,
                        height: 0,
                        borderLeft: "6px solid transparent",
                        borderRight: "6px solid transparent",
                        borderTop: "6px solid #333"
                    }}></div>
                </div>
            </button>
        </div>
    );
};

export default DiceAiButton; 